function say(msg: string): void {
  console.log(msg)
}

window.onload = () => say("Hello")
